export default __webpack_public_path__ + "static/media/1.930a911e.svg";